import { useEffect, useState, useRef } from 'react';
import { supabase } from '../lib/supabase.js';

// Lazily loads out-of-scope vineyards for the current region. Only fetches
// when `enabled` (toggle on + logged in + region view); returns null otherwise
// so nothing loads by default and the layer clears on toggle-off / logout /
// leaving the region.
export function useOutOfScopeVineyards(mode, enabled) {
  const [data, setData] = useState(null);
  const reqId = useRef(0);

  const region = mode.kind === 'region' ? mode.name : null;
  const active = enabled && !!region;

  useEffect(() => {
    if (!active) {
      reqId.current++;
      setData(null);
      return;
    }
    const myReq = ++reqId.current;
    supabase
      .rpc('out_of_scope_vineyards_by_region', { p_region: region })
      .then(({ data: rpc, error }) => {
        if (myReq !== reqId.current) return;
        if (error) { setData(null); return; }
        setData(rpc);
      });
  }, [active, region]);

  return data;
}
